// extracted by mini-css-extract-plugin
module.exports = {"title":"view-successful-activation_title__-DkKu"};